<template>
    <div class="DamageStat">
        <div class="DamageStatLabel">{{ Label }}</div>
        <div class="DamageStatCount">{{ Count }}</div>
    </div>
</template>

<script>
export default{
    props:{
        Label: String,
        Count: Number,
    }
}
</script>

<style>
.DamageStat
{
    
}

.DamageStat + .DamageStat
{
    margin-left: 10px;
}

.DamageStatLabel
{
    text-align: center;
}

.DamageStatCount
{
    text-align: center;
}
</style>